import React, { useState, useEffect } from "react";
import "../Products/Products.css"; // Using the same CSS file as the Product component for consistent styling
import "./grid.css"
import axiosConfig from "../../Service/axiosConfig";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addProduct, removeProduct, selectCartTotal } from "../../redux/Slices/cartSlice";
import WishlistIcon from "../Wishlist";
import { AccessDeny, LocationModal } from "../PopupModal";
import { TfiTimer } from "react-icons/tfi";

const ProductGrid = ({ Setlogin, LoginAccount }) => {
  const [img, setImg] = useState([]);
  const [products, setProducts] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart);
  const [showMessage, setShowMessage] = useState({});
  const [LocationpopupType, setLocationpopupType] = useState("");
  const [NoAccess, setNoAccess] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);

  useEffect(() => {
    // Fetch products (assuming you need to fetch products in this component)
    axiosConfig
      .get("/catlog/products/?subcategory=&is_suspended=false")
      .then((response) => {
        console.log(response.data.results)
        setProducts(response.data.results.slice(0, 8)); // Only show 8 products
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []);
  useEffect(() => {
    // Fetch products (assuming you need to fetch products in this component)
    axiosConfig
      .get("/catlog/banners/?banner_type=vertical_banner&is_suspended=false")
      .then((response) => {
        console.log(response.data.results)
        setImg(response.data.results);
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []);


  const handleResize = () => {
    setIsMobile(window.innerWidth < 1020);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
  };

  const getProductQuantity = (productId) => {
    const product = cart.products.find((p) => p.id === productId);
    return product ? product.quantity : 0;
  };

  const addToCart = (product) => {
    dispatch(
      addProduct({
        product: {
          id: product.id,
          name: product.name,
          image: product.image,
          price: product.price,
          offer_price: product.offer_price,
          weight_in_kg: product.weight_in_kg,
          max_qty: product.max_qty,
          subcategory: product.subcategory,
          speed: product.category,
        },
        quantity: 1,
      })
    );
  };

  const removeFromCart = (productId) => {
    dispatch(removeProduct({ productId, quantity: 1 }));
  };

  const showMaxQuantityMessage = (productId) => {
    setShowMessage((prevState) => ({
      ...prevState,
      [productId]: true
    }));
    setTimeout(() => {
      setShowMessage((prevState) => ({
        ...prevState,
        [productId]: false
      }))
    }, 2000);
  };

  function HanldeSlug() {
    navigate()
  }

  const addToCartWithCondition = (product) => {
    const siteData = JSON.parse(localStorage.getItem("site_data"));
    if (siteData && siteData.ecommerce_type !== "Conventional") {
      if (localStorage.getItem("storeId")) {
        addToCart(product);
      } else {
        setLocationpopupType("success");
      }
    } else {
      addToCart(product);
    }
  };

  return (
    <>
      <div className="product-grid-container">
        <div className="right-banner">
          <div className="banner-card right-banner-img">
            {
              img.slice(0, 1).map((imgs, ind) => (
                <div key={ind} onClick={() => navigate(`/${imgs.slug}`)}><img src={imgs.image.image} /></div>
              ))
            }
          </div>
          <div className="right-banner-data">
            {products.slice(0, 4).map((product, index) => {
              const currentQuantity = getProductQuantity(product.id);
              return (
                <div className="product-item product-item-grid" key={index}>
                  <div className="product-wish-icon">
                    {product.available && (
                      <WishlistIcon
                        productId={product.id}
                        LoginAccount={LoginAccount}
                        Setlogin={Setlogin}
                      />
                    )}
                  </div>
                  {product.discount_percentage > 0 && (
                    <div className="discount_icon_container">
                      <div className="discount_percentage">
                        {product.discount_percentage}% OFF
                      </div>
                    </div>
                  )}
                  <div
                    className="product-img"
                    onClick={() =>
                      handleNavigate(`/${product.slug}`)
                    }
                  >
                    <img
                      src={product.image ? product.image.image : product.image}
                      alt={product.name}
                    />
                    {!product.available && (
                      <div className="product-overlay">Out of Stock</div>
                    )}
                  </div>
                  {localStorage.getItem("site_data") &&
                    JSON.parse(localStorage.getItem("site_data")).ecommerce_type !==
                    "Conventional" &&
                    localStorage.getItem("express_delivery_time") && (
                      <div className="timer">
                        <TfiTimer size={10} />
                        <span>{localStorage.getItem("express_delivery_time")} mins</span>
                      </div>
                    )}
                  <p
                    className="name"
                    onClick={() =>
                      handleNavigate(`/${product.slug}`)
                    }
                  >
                    {product.name}
                  </p>
                  <div className="product-weight">
                    {product.weight} {product.measurement_unit}
                  </div>
                  <div className="product-actions">
                    <div className="p-price">
                      {product.offer_price && product.offer_price > 0 ? (
                        <>
                          <p className="price">₹{product.offer_price}</p>
                          <p className="produc-price">₹{product.price}</p>
                        </>
                      ) : (
                        <p className="price">₹{product.price}</p>
                      )}
                    </div>
                    <div className="p-btn">
                      {currentQuantity > 0 ? (
                        <div className="btn btn-cart btn-cart-added">
                          <button
                            className="btn-minus"
                            onClick={() => removeFromCart(product.id)}
                          >
                            <div className="custom-minus"></div>
                          </button>
                          <div className="qty">{currentQuantity}</div>
                          <button
                            className="btn-plus"
                            onClick={() =>
                              currentQuantity === product.max_qty
                                ? showMaxQuantityMessage(product.id)
                                : addToCart(product)
                            }
                          >
                            <div className="custom-plus"></div>
                          </button>
                        </div>
                      ) : product.available ? (
                        <button
                          className="btn btn-cart"
                          onClick={() => addToCartWithCondition(product)}
                        >
                          Add
                        </button>
                      ) : null}
                    </div>

                    {LocationpopupType === "success" && (
                      <LocationModal
                        LocationpopupType={LocationpopupType}
                        setLocationpopupType={setLocationpopupType}
                      />
                    )}

                    {NoAccess === "success" && (
                      <AccessDeny NoAccess={NoAccess} setNoAccess={setNoAccess} />
                    )}
                  </div>
                  {showMessage[product.id] && (
                    <div
                      className="custom-message"
                      style={{ position: "absolute", top: "77%" }}
                    >
                      Sorry, you have reached the maximum quantity.
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="right-banner">
          <div className="banner-card right-banner-img">
            {
              img.slice(1).map((imgs, ind) => (
                <div key={ind} onClick={() => navigate(`/${imgs.slug}`)}><img src={imgs.image.image} /></div>
              ))
            }
          </div>
          <div className="right-banner-data">
            {products.slice(4, 8).map((product, index) => {
              const currentQuantity = getProductQuantity(product.id);
              return (
                <div className="product-item product-item-grid" key={index}>
                  <div className="product-wish-icon">
                    {product.available && (
                      <WishlistIcon
                        productId={product.id}
                        LoginAccount={LoginAccount}
                        Setlogin={Setlogin}
                      />
                    )}
                  </div>
                  {product.discount_percentage > 0 && (
                    <div className="discount_icon_container">
                      <div className="discount_percentage">
                        {product.discount_percentage}% OFF
                      </div>
                    </div>
                  )}
                  <div
                    className="product-img"
                    onClick={() =>
                      handleNavigate(`/${product.slug}`)
                    }
                  >
                    <img
                      src={product.image ? product.image.image : product.image}
                      alt={product.name}
                    />
                    {!product.available && (
                      <div className="product-overlay">Out of Stock</div>
                    )}
                  </div>
                  {localStorage.getItem("site_data") &&
                    JSON.parse(localStorage.getItem("site_data")).ecommerce_type !==
                    "Conventional" &&
                    localStorage.getItem("express_delivery_time") && (
                      <div className="timer">
                        <TfiTimer size={10} />
                        <span>{localStorage.getItem("express_delivery_time")} mins</span>
                      </div>
                    )}
                  <p
                    className="name"
                    onClick={() =>
                      handleNavigate(`/${product.slug}`)
                    }
                  >
                    {product.name}
                  </p>
                  <div className="product-weight">
                    {product.weight} {product.measurement_unit}
                  </div>
                  <div className="product-actions">
                    <div className="p-price">
                      {product.offer_price && product.offer_price > 0 ? (
                        <>
                          <p className="price">₹{product.offer_price}</p>
                          <p className="produc-price">₹{product.price}</p>
                        </>
                      ) : (
                        <p className="price">₹{product.price}</p>
                      )}
                    </div>
                    <div className="p-btn">
                      {currentQuantity > 0 ? (
                        <div className="btn btn-cart btn-cart-added">
                          <button
                            className="btn-minus"
                            onClick={() => removeFromCart(product.id)}
                          >
                            <div className="custom-minus"></div>
                          </button>
                          <div className="qty">{currentQuantity}</div>
                          <button
                            className="btn-plus"
                            onClick={() =>
                              currentQuantity === product.max_qty
                                ? showMaxQuantityMessage(product.id)
                                : addToCart(product)
                            }
                          >
                            <div className="custom-plus"></div>
                          </button>
                        </div>
                      ) : product.available ? (
                        <button
                          className="btn btn-cart"
                          onClick={() => addToCartWithCondition(product)}
                        >
                          Add
                        </button>
                      ) : null}
                    </div>

                    {LocationpopupType === "success" && (
                      <LocationModal
                        LocationpopupType={LocationpopupType}
                        setLocationpopupType={setLocationpopupType}
                      />
                    )}

                    {NoAccess === "success" && (
                      <AccessDeny NoAccess={NoAccess} setNoAccess={setNoAccess} />
                    )}
                  </div>
                  {showMessage[product.id] && (
                    <div
                      className="custom-message"
                      style={{ position: "absolute", top: "77%" }}
                    >
                      Sorry, you have reached the maximum quantity.
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductGrid;
